<template>
  <footer class="footer">
    <div v-if="forbiddenFooterPages.indexOf( currentUrl ) === -1 " class="sheet-1" style="justify-content: center;">
        <div class="centered">
            <div class="categorybox">
                <div class="box-1">
                    <h1 class="category h1-custom">{{$t('company')}}</h1>
                    <ul class="list">
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/company'"  class="subcategory">{{$t('about-company')}}</a></li>
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/faq'" class="subcategory">{{$t('help-center')}}</a></li>
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/subscribe'"  class="subcategory">{{$t('news')}}</a></li>
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/contact'" class=" custom-bottom-footer subcategory">{{$t('contact')}}</a></li>
                    </ul>
                </div>
                <div class="box-1">
                    <h1 class="category h1-custom">{{$t('application')}}</h1>
                    <ul class="list">
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/app'" class="subcategory">{{$t('overview')}}</a></li>
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/app#whypixcham'" class="subcategory">{{$t('why-pixcham-1')}}</a></li>
                        <li style="line-height: 1.2;"><a
                  href="https://testflight.apple.com/join/2M2QVLWq"
                  class="f-link  custom-bottom-footer subcategory"
                >{{$t('download-ios-app')}}</a></li>
                        <li style="line-height: 1.2;"><a
                  href="https://play.google.com/apps/testing/com.pixcham"
                  class="f-link  custom-bottom-footer subcategory"
                >{{$t('download-android-app')}}</a></li>
                    </ul>
                </div>
                <div class="box-1">
                    <h1 class="category h1-custom">{{$t('influencer')}}</h1>
                    <ul class="list">
                      <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/influencer'" class="subcategory">{{$t('overview')}}</a></li>
                      <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/influencer#benefits'" class="subcategory">{{$t('benefits')}}</a></li>
                      <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/influencer#makeadeal'" class="subcategory">{{$t('conditions')}}</a></li>
                      <li style="line-height: 1.2;"><a href="" class="subcategory">{{$t('create-profile')}}</a></li>
                    </ul>
                </div>

                <div class="box-1">
                    <h1 class="category h1-custom">Business</h1>
                    <ul class="list">
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/business'"   class="subcategory">{{$t('overview')}}</a></li>
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/business#gamemode-section'" class="subcategory">{{$t('game-modes')}}</a></li>
                        <li style="line-height: 1.2;"><router-link to="/challenge/location"  class="f-link  custom-bottom-footer subcategory">{{$t('create-challenge-2')}}</router-link></li>
                        <li style="line-height: 1.2;"><router-link to="/login"  class="f-link  custom-bottom-footer subcategory">{{$t('login')}}</router-link></li>
                    </ul>
                </div>
                
                <div class="box-1">
                    <h1 class="category h1-custom">{{$t('legal')}}</h1>
                    <ul class="list">
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/terms'" class="subcategory">{{$t('terms&conditions')}}</a></li>
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/privacy'" class="subcategory">{{$t('privacy-policy')}}</a></li>
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/guidelines'" class="subcategory">{{$t('community-guidelines')}}</a></li>
                        <li style="line-height: 1.2;"><a :href="'https://'+( getLang && getLang !== 'en' ? getLang : 'www')+'.pixcham.com/partners'" class="subcategory">{{$t('partners')}}</a></li>
                    </ul>
                </div>
                <div class="box-1-l">

                    <a style="display:flex; text-decoration: none; color: #282731;" href="">

                        <img class="langicon" src="https://business.pixcham.com/icons/globe.svg" alt="" />
                        <h1 class="category-l" style="margin: 0px;" >{{$t('language')}}</h1>
                    </a>
                </div>
            </div>

            <div class="logoicon-box">
                <a href=""><img class="logo" src="https://data.pixcham.com/images/main/footer_logo.svg" alt="" /></a>
                <p class="copyright p-custom">© 2023 Pixcham International j.s.a. All rights reserved</p>
                <div class="social-box">
                    <a class="linkicon" target="_blank" href="https://instagram.com/pixcham_official?igshid=MzRlODBiNWFlZA==">
                        <img class="iconsocial" src="https://business.pixcham.com/icons/instagram.svg" alt="" /></a>
                    <a class="linkicon" href=""><img class="iconsocial" src="https://business.pixcham.com/icons/facebook.svg" alt="" /></a>
                    <a class="linkicon" href=""><img class="iconsocial" src="https://business.pixcham.com/icons/tik_tok.svg" alt="" /></a>
                    <a class="linkicon" href=""><img class="iconsocial" src="https://business.pixcham.com/icons/twitter.svg" alt="" /></a>
                    <a class="linkicon" href="" style="margin-right: 0px;">
                        <img class="iconsocial" src="https://business.pixcham.com/icons/youtube.svg" alt="" />
                    </a>
                </div>
            </div>
        </div>
    </div>
  </footer>
</template>
<script>
import { langs } from "../assets/locale/index.js";
import { counts } from "../assets/locale/index.js";
import axios from "axios";

export default {
  data() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin'
      },
      activeLang: this.$store.getters.activeLang,
      activeCountry: this.$store.getters.activeCountry,
      languages: langs,
      countries: counts,
      windowWidth: window.innerWidth,
      refreshNumber: 1,
      forbiddenFooterPages : ['/reports', '/challenge-setup', '/challenges', '/users', '/admin-hub', '/tasks', '/emails', '/promo-list', '/schedule', '/my-challenges', '/my-reports', '/my-winners', '/members', '/team', '/invited', '/invoices', '/email-setup']
    };
  },
  computed: {
    getLang() {
      return this.$store.getters.activeLang;
    },
    returnCountry() {
      return this.$store.getters.activeCountry;
    },
    currentUrl() {
      return this.$route.path;
    }
  },
  watch:{
    returnCountry( newCount, oldCount ) {
      if( newCount !== oldCount )
      {
        this.activeCountry = newCount;

        if( this.$store.state.userLoggedIn )
        {
          this.submitCountry();
        }
      }
    },
    getLang( newCount, oldCount ) {
      if( newCount !== oldCount )
      {
        this.activeLang = newCount;
      }
    }
  },
  methods: {
    resized()
    {
      this.windowWidth = window.innerWidth;
    },
    submitCountry() {
      axios.post(this.$store.getters.enviromentURL + '/setCountry', { country: this.activeCountry },
        { headers: this.headers })
        .then(response => {

        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    openAllCountries()
    {
      this.$store.commit('updateOpenCountries', true)
    },
    scrollToTop() {
      //console.log('scrollToTop');
      window.scrollTo(0, 0);
    }
  },
  components: {

  },
  mounted() {

    window.addEventListener('resize', () => {
      this.resized();
    });

    if( !this.$store.state.userLoggedIn )
    {
      console.log('AAAAAAAAAAAAAAAAAAA');
      /*
      let country = navigator.language.toLowerCase() || 'en-gb';
      let language = country.split('-')[0];

      this.$i18n.locale = language;
      this.$store.commit("updateActiveLang", language);
      this.$store.commit('updateActiveCountry', country );
      */
    }

    //this.activeLang = this.getLang;
    //if (this.activeLang) {
      //console.log('Update locale?????',this.activeLang)
      //this.$i18n.locale = this.activeLang;
    //}
  }
};
</script>
<style>

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
    
.h1-custom{
  text-align:left;
  margin-bottom: 0px;
}

.p-custom{
  margin: 0px;
}

.footer{
    position: relative;
    background-color: #eeedee;
      
  }
  .footer .sheet-1{
    min-height: 300px;
    max-width: 1200px;
    margin: auto;
    padding-left: 50px;
    padding-right: 50px;
    align-items: center;
    justify-content: center;
    color: #282731;
  
  }
    .footer .centered{
      transform: translate(0%, 15%);
  
  }
  .footer .categorybox{
    display: flex;
    padding-bottom: 25px;
    border-bottom: 1px solid #a4a4a4;
    justify-content: space-between;
    flex-wrap: wrap;
  
  }
  .footer .box-1{
    flex: 0 0 auto;
    
  }
  .footer .category{
    font-size: 16px;
    padding-bottom: 10px;
    font-family: 'LatoBold';
  
  }
  
  .footer .list{
    line-height: 1.5;
    list-style-type: none;
  }
  
  .footer .subcategory{
    font-size: 14px;
    font-family: 'LatoRegular';
    text-decoration: none;

    color: #282731;
  }
  
  .subcategory:hover{
    text-decoration: underline;
  }
  
  .footer .logoicon-box{
   padding-top: 25px;
   display: flex;
   flex-direction: row;
   align-items: center;
  }
  
  .footer .logo{
    
  }
  
  
  .footer .social-box{
    margin-left: auto; 
    margin-right: 0;
    gap: 50px;
  }
  
  .footer .iconsocial{
    height: 22px;
    width: auto;
    transition: transform .2s;
  }
  
  .footer .linkicon{
    margin-right: 18px;
  }
  
  .iconsocial:hover{
    transform: scale(1.1);
  
  }
  
  
  .footer .copyright{
    font-size: 14px;
    font-family: 'LatoRegular';
    color: #a4a4a4;
    padding-left: 20px;
    text-align: left;
  }
  .footer .language-selector{
    display: none;
   
    
  }
  .footer .formselector {
    display: none;
    
  }
  .footer .box-1-l{
    display: none;
    
  }
  .footer .category-l{
    display: none;
  
  }
  
  @media (min-width: 768px) and (max-width: 1024px) 
    and (orientation: landscape) {
  
  
      .footer{
        position: relative;
        background-color: #eeedee;
          
      }
      .footer .sheet-1{
        min-height: 300px;
        max-width: 1200px;
        margin: auto;
        padding-left: 50px;
        padding-right: 50px;
        align-items: center;
        justify-content: center;
      
       
       
      }
      .footer .categorybox{
        display: flex;
        padding-bottom: 25px;
        border-bottom: 1px solid #a4a4a4;
        justify-content: space-between;
        flex-wrap: wrap;
      
      }
      .footer .box-1{
        flex: 0 0 auto;
        
      }
      .footer .category{
        font-size: 16px;
        padding-bottom: 10px;
        font-family: 'LatoBold';
      
      }
      
      .footer .list{
        line-height: 1.5;
        list-style-type: none;
       
      }
      
      .footer .subcategory{
        font-size: 14px;
        font-family: 'LatoRegular';
        text-decoration: none;
        color: black;
      }
      
      .subcategory:hover{
        text-decoration: underline;
      }
      
      .footer .logoicon-box{
       padding-top: 25px;
       display: flex;
       flex-direction: row;
       align-items: center;
      }
      
      .footer .logo{
        
      }
      
      .footer .social-box{
        margin-left: auto; 
        margin-right: 0;
        gap: 10px;
      }
      
      .footer .iconsocial{
        height: 16px;
        width: auto;
        transition: transform .2s;
      }
      
      .footer .linkicon{
        margin-right: 35px;
      }
      
      .iconsocial:hover{
        transform: scale(1.1);
      
      }
      
      
      .footer .copyright{
        font-size: 14px;
        font-family: 'LatoRegular';
        color: #a4a4a4;
        padding-left: 20px;
      }
  
  }
  @media (min-width: 760px) and (max-width: 1024px)
  and (orientation: portrait) {  
  
  
      .footer{
        position: relative;
        background-color: #eeedee;
          
      }
      .footer .sheet-1{
        min-height: 300px;
        max-width: 1200px;
        margin: auto;
        padding-left: 30px;
        padding-right: 30px;
        align-items: center;
        justify-content: center;
      
       
       
      }
      .footer .categorybox{
        display: flex;
        padding-bottom: 25px;
        border-bottom: 1px solid #a4a4a4;
        justify-content: space-between;
        flex-wrap: wrap;
      
      }
      .footer .box-1{
        flex: 0 0 auto;
        
      }
      .footer .category{
        font-size: 16px;
        padding-bottom: 10px;
        font-family: 'LatoBold';
      
      }
      
      .footer .list{
        line-height: 1.5;
        list-style-type: none;
       
      }
      
      .footer .subcategory{
        font-size: 14px;
        font-family: 'LatoRegular';
        text-decoration: none;
        color: black;
      }
      
      .subcategory:hover{
        text-decoration: underline;
      }
      
      .footer .logoicon-box{
       padding-top: 25px;
       display: flex;
       flex-direction: row;
       align-items: center;
      }
      
      .footer .logo{
        
      }
      
      .footer .social-box{
        margin-left: auto; 
        margin-right: 0;
        gap: 30px;
      }
      
      .footer .iconsocial{
        height: 16px;
        width: auto;
        transition: transform .2s;
      }
      
      .footer .linkicon{
        margin-right: 25px;
      }
      
      .iconsocial:hover{
        transform: scale(1.1);
      
      }
      
      
      .footer .copyright{
        font-size: 14px;
        font-family: 'LatoRegular';
        color: #a4a4a4;
        padding-left: 20px;
      }
  
  }
  
  @media (min-width: 375px) 
    and (max-width: 760px){ 
  
  
      .footer{
        position: relative;
        background-color: #eeedee;
          
      }
      .footer .sheet-1{
        min-height: 700px;
        max-width: 1200px;
        margin: auto;
        padding-left: 40px;
        padding-right: 40px;
        align-items: center;
        justify-content: center;
      }
        .footer .centered{
          transform: none;
          align-items: center;
          padding-top: 30px;
      
    
       
      }
      .footer .categorybox{
        display: flex;
        padding-bottom: 25px;
        border-bottom: 1px solid #a4a4a4;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-left: 30px;
      
      }
      .footer .box-1{
        flex: 0 0 50%;
        margin-top: 12px;
        margin-bottom: 12px;
        
        
      }
      .footer .category{
        font-size: 16px;
        padding-bottom: 10px;
        font-family: 'LatoBold';
      
      }
  
      .footer .box-1-l{
        flex: 0 0 50%;
        margin-top: 12px;
        margin-bottom: 12px;
        display: block;
        
      }
      .footer .category-l{
        font-size: 16px;
        padding-bottom: 10px;
        font-family: 'LatoBold';
        display: block;
      
      }
      
      .footer .list{
        line-height: 1.5;
        list-style-type: none;
       
      }
      
      .footer .subcategory{
        font-size: 14px;
        font-family: 'LatoRegular';
        text-decoration: none;
        color: black;
      }
      
      .subcategory:hover{
        text-decoration: underline;
      }
        
      .footer .langicon{
        width: 15px;
        height: 21px;
        margin-right: 8px;
      } 
  
  
  
  
      .footer .logoicon-box{
       padding-top: 25px;
       display: flex;
       flex-direction: column;
       align-items: center;
      }
      
      .footer .logo{
        
      }
      
      .footer .social-box{
        margin-left: auto; 
        margin-right: auto;
        gap: 30px;
      }
      
      .footer .iconsocial{
        height: 16px;
        width: auto;
        transition: transform .2s;
      }
      
      .footer .linkicon{
        margin-right: 25px;
      }
      
      .iconsocial:hover{
        transform: scale(1.1);
      
      }
      
      
      .footer .copyright{
        font-size: 14px;
        font-family: 'LatoRegular';
        color: #a4a4a4;
        padding-left: 0px;
        padding-top: 8px;
        padding-bottom: 20px;
        text-align: center;
      }
  
  
  
  
  }
  
  @media (min-width: 310px) 
  and (max-width: 375px){ 
  .footer .sheet-1{
    min-height: 730px;
    max-width: 1200px;
    margin: auto;
    padding-left: 40px;
    padding-right: 40px;
    align-items: center;
    justify-content: center;
}
}
  

</style>